import { Grid } from "@mui/material";
import { LeavePlansForAdmin } from "app/components/leave-plans/LeavePlansForAdmin";
import { HolidayListView } from "app/components/leave-plans/HolidayListView";

export const LeavePlanAdminView = () => {
    return (
        <div className="content-container" style={{width: "100%" }}>
            <Grid container spacing={6}>
                <LeavePlansForAdmin />
                <HolidayListView />
            </Grid>
        </div>
    );
}